import api from '../services/api';
import { isAccessTokenValid } from './AuthController';

export const getAllUser = async () => {
    try {
        await isAccessTokenValid();
        const response = await api.get('/user');
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const getUserByID = async (id) => {
    try {
        await isAccessTokenValid();
        const response = await api.get(`/user/${id}`);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const createUser = async (data) => {
    try {
        await isAccessTokenValid();
        const response = await api.post('/user', data);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const updateUser = async (id, data) => {
    try {
        await isAccessTokenValid();
        const response = await api.put(`/user/${id}`, data);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const deleteUser = async (id) => {
    try {
        await isAccessTokenValid();
        const response = await api.delete(`/user/${id}`);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};
